import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v2/colors";
import { radius } from "#app/theme/v2/radius";
import { spacing } from "#app/theme/v2/spacing";
import { Title } from "#components/atoms/Typographies/Title";
import { Flex } from "#shared/view/components/Flex";

type Props = {
  isFilling?: boolean;
  children: ReactNode;
};

export const NestingPlanCard = ({ isFilling, children }: Props) => {
  const { t } = useTranslation();

  return (
    <Flex
      direction="column"
      flex={isFilling ? 1 : undefined}
      gap={spacing[5]}
      px={spacing[6]}
      pt={spacing[5]}
      pb={spacing[6]}
      style={{ backgroundColor: colors.bg.elevation.tertiary, borderRadius: radius.md }}
    >
      <Title size="tiny">{t("layout.sidePanel.cuttingPlan")}</Title>
      {children}
    </Flex>
  );
};
